import { useReactFlow } from '@xyflow/react';
import { useHotkeys } from 'react-hotkeys-hook';

export function useZoomShortcuts() {
  const { fitView, zoomIn, zoomOut, zoomTo } = useReactFlow();

  useHotkeys(
    'meta+=,ctrl+=,meta+shift+=,ctrl+shift+=',
    () => zoomIn(),
    {
      preventDefault: true,
    },
    [zoomIn],
  );

  useHotkeys(
    'meta+minus,ctrl+minus,meta+shift+minus,ctrl+shift+minus',
    () => zoomOut(),
    {
      preventDefault: true,
    },
    [zoomOut],
  );

  useHotkeys(
    'meta+0,ctrl+0',
    () => zoomTo(1),
    {
      preventDefault: true,
    },
    [zoomTo],
  );

  useHotkeys(
    'shift+1',
    () => fitView(),
    {
      preventDefault: true,
    },
    [fitView],
  );
}
